export default __webpack_public_path__ + "static/media/bills.1c9fbc43.svg";